import type { ReactNode } from "react";

export function Section({
  title,
  children,
  hint,
  action,
}: {
  title: string;
  children: ReactNode;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <section>
      <div className="mb-1.5 flex items-center justify-between">
        <h2 className="eyebrow">{title}</h2>
        {action}
      </div>
      {children}
      {hint ? (
        <p className="mt-1 text-[11px] leading-snug" style={{ color: "var(--muted-2)" }}>
          {hint}
        </p>
      ) : null}
    </section>
  );
}
